<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getLocalVersion } from '@/api'
import localForage from 'localforage'
export default {
  name: 'App',
  watch: {
    lang: {
      handler(nv) {
        const langType = {
          zh: 'language_zh',
          en: 'language_en',
        }
        document.getElementsByTagName('body')[0].classList.add(langType[nv || 'zh'])
      },
      immediate: true,
    },
  },
  created() {
    this.getLocalVersion()
  },
  methods: {
    // indexdb版本更新
    getLocalVersion() {
      getLocalVersion().then(async res => {
        let oldVersion = await localForage.getItem('version')

        if (!oldVersion) {
          localForage.clear().then(() => {
            localForage.setItem('version', res.data)
          })
        } else {
          //获取数据仓库中所有的 key。
          const keys = await localForage.keys()
          //过滤不存在数据库仓库的key
          oldVersion = oldVersion.filter(item => keys.indexOf(item.key) !== -1)

          //获取最新版本和历史版本比较
          const newVersion = res.data
          oldVersion.forEach(item => {
            const versionItemIndex = newVersion.findIndex(newItem => newItem.key === item.key)
            const versionItem = newVersion[versionItemIndex]
            if (versionItem && versionItem.version !== item.version) {
              localForage.removeItem(item.key)
            }
          })
          localForage.setItem('version', res.data)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/font/iconfont.css';
@import '@/assets/styles/index.scss';

#app {
  color: #2c3e50;
  font-family: Noto Sans SC;
  font-weight: 300;
  font-size: $font-14;
  word-break: break-all;
  position: relative;
}
</style>
